import { useEffectWithController } from '@carvana/merch-react-hooks';
import { useContext } from 'react';
import TradeContext from '~/context/common/TradeContext';
import { useUserId } from '~/context/common/UserContext';
import FinanceContext from '~/context/home/FinanceContext';
import { fetchCreditStatus } from '~/services/home';
import { generateErrorLogger } from '~/utilities/loggers';

export default function useGetCreditStatus(isLoggedIn: boolean) {
  const {
    financeInfo: { setData, setError, setLoading },
    fetchFinanceTrigger
  } = useContext(FinanceContext);
  const userId = useUserId();
  const {
    activeTrade,
    trades: { isLoaded: isTradesLoaded }
  } = useContext(TradeContext);

  const tradeEquity = activeTrade?.offerAmount ?? 0; //TODO: check if this is the correct value

  useEffectWithController(
    controller => {
      if (isLoggedIn && !isTradesLoaded) return;

      if (!isLoggedIn) {
        setData({});

        return;
      }

      setLoading();

      fetchCreditStatus({ userId, tradeEquity }, controller)
        .then(({ status, data }) => {
          if (status === 200) {
            setData(data);
          }
          // 204 is returned when the user has no credit status history and data is an empty string
          if (status === 204) {
            setData({});
          }
        })
        .catch(
          generateErrorLogger(
            'Get finance info',
            {},
            { callback: setError, controller }
          )
        );
    },
    [
      fetchFinanceTrigger,
      isLoggedIn,
      isTradesLoaded,
      setData,
      setError,
      setLoading,
      tradeEquity,
      userId
    ]
  );
}
